<template lang="pug">
include /mixins
+b.ticket-form#form
  +e.head(v-if='!success')
    +e.title.H1 {{ _('Анкета участника') }}
    +b.ambassador-steps
      +b.ambassador-step(
        v-for='step in steps'
        :key='step'
        @click='goNext(step)'
        :class='{ "is-active": step === currentStep, "is-past": step < currentStep }'
      ) 0{{ step }}
  +b.non-field-error-label.ds-caption--appearance_left.P(v-if="non_field_errors") {{ non_field_errors[0] }}
  //- +e.text.P(v-if='!success && currentStep == 3') {{ _('Следующие поля необязательны для заполнения, но мы будем благодарны за дополнительные детали участника') }}
  +b.VALIDATION-OBSERVER(
    ref="validator",
    v-slot="{ valid }",
    v-if='!success'
    tag="form",
  )
    ui-loader(v-if='isLoad')
    +b.form-fields(
      v-for='{ fields, title, description } in form_fields[currentStep-1]'
    )
      +e.title.P {{ title }}
      +b.g-row
        +b.g-cell.g-cols--12.tt-space_mt--6(
          v-for='{ rules, name, label, tag, classname,events, errorClasses, mask, type, props, cols, afterList } in fields'
          :class='`g-cols--${cols || 12}-xl`'

        )
          tag(
            :tag='tag || "d-control-input"'
            :rules="rules",
            :input-label='label'
            v-model='form[name]',
            :ref='name'
            v-bind='props'
            v-on='events'
            @input='$emit("update", form)'
            :form='form'
            :name='name'
            :type='type || "text"'
            :key='name'
            :class='classname',
            :error-classes='errorClasses'
            @load='isLoad = $event'
            :ticket='ticket'
            :ticket_hash='ticket_hash'
          )
            template(
              #afterList=''
              v-if='afterList'
            )
              div
                div(
                  v-if="props.options.length > 50 || props.pagination.next "
                  v-observe-visibility="visible => afterList(visible)",
                )
          +b.ds-caption--size_xs.P.tt-space_mt--2(v-if='description') {{ description }}
    +b.g-row--justify_between
      +b.g-cell.g-cols
        +b.tt-space_mt--6
          +b.tt-button--auto.--bordered_main.BUTTON(
            type='submit'
            v-if='currentStep > 1',
            @click.prevent='goNext(currentStep - 1)'
          )
            +e.title.P {{ _('Предыдущий шаг') }}
      +b.g-cell.g-cols
        +b.tt-space_mt--6
          +b.tt-button--auto.BUTTON(
            :disabled='isLoad',
            @click.prevent='goNext'
          )
            +e.title.P {{ currentStep == 3 ? _('Отправить') : _('Следующий шаг') }}
  +e.result(v-else)
    +b.ticket_management-form-result
      +e.title.P {{ _('Готово! Мы получили Ваши данные') }}
      +e.img-wrap
        +e.img(
          src='/static/img/totik/like.svg'
          alt='success'
        )
      +e.text.P {{ _('Мы проверим ваши данные и документы в течение 5 рабочих дней.') }} &nbsp;
        span(v-if='url') {{ _('После подтверждения вы сможете загрузить PDF-билет с QR-кодом, который будет необходим для входа на мероприятие.') }} &nbsp;
        span(v-if='url') {{ _('Статус билета автоматически обновляется - Вы получите уведомление.') }}
      +e.btn(v-if='url')
        +b.tt-button--auto.A(
          :href='url'
        )
          +e.title.P {{ _('Вернуться к моим билетам') }}
      +e.btn(v-else)
        +b.tt-button--auto.A(
          :href='home'
        )
          +e.title.P {{ _('На главную') }}
</template>
<script>
import {
  pathOr,
} from 'ramda'

import {
  SPECIALIZATION_URL,
  PARTICIPANT_SERVICES_URL,
  participantCreate,
  createSocialLink,
  destroySocialLink,
  updateSocialLink,
} from '@api/ticket_management.service'

import {
  NOVAPOSHTA_CITIES_LINK,
} from '@api/order.service'

import {
  getCookie,
} from '@utils/cookies'

import {
  BRAND_LIST_URL,
} from '@api/catalog.service'

import {
  COUNTRY_CODE_COOKIE_NAME,
  UKRAINE_CODE,
} from '@app/consts'

import {
  getPaginatedPropsForArray,
} from '@utils/valuesGetter'

import { asyncForEach } from '@utils/async'

import TicketFileLoader from '@app/Staff/Ticket/FileLoader'
import TicketManagementEducation from '@app/TicketManagement/Education'
import TicketManagementPhoto from '@app/TicketManagement/Photo'
import TicketManagementRadioSelect from '@app/TicketManagement/RadioSelect'
import TicketManagementCustomRadioSelect from '@app/TicketManagement/CustomRadioSelect'
import TicketManagementInliner from '@app/TicketManagement/Inliner'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'
import {
  readFileAsync,
} from '@utils/file'
import 'flatpickr/dist/plugins/monthSelect/style.css'

const IS_PHONE = 'phone'
const IS_EMAIL = 'email'
const IS_OTHER = 'other'

const YEARS = Array.from({ length: 50 }, (v, i) => {
  const r = new Date().getFullYear() - i
  return { key: r.toString(), value: r }
})

export const documentOffsetTop = el => {
  let offset = 0
  while (el) {
    offset += el.offsetTop
    el = el.offsetParent
  }
  return offset
}

export default {
  name: 'TicketCreate',
  mixins: [FormMixin],
  props: {
    ticket: {},
    url: {},
    ticket_hash: {
      type: String,
      default: '',
    },
  },
  components: {
    TicketFileLoader,
    TicketManagementEducation,
    TicketManagementPhoto,
    TicketManagementRadioSelect,
    TicketManagementCustomRadioSelect,
    TicketManagementInliner,
  },
  data() {
    return {
      home: window.indexPage,
      success: false,
      steps: [1, 2, 3],
      currentStep: 1,
      appeals: [],
      form_fields: [[
        {
          title: this._('Укажите Вашу фамиию, имя и отчество на украинском языке'),
          fields: [
            {
              name: 'last_name',
              label: this._('Фамилия'),
              rules: 'required',
            },
            {
              name: 'first_name',
              label: this._('Имя'),
              rules: 'required',
            },
            {
              name: 'middle_name',
              label: this._('Отчество'),
              rules: 'required',
            },
          ],
        },
        {
          title: this._('Пожалуста, укажите актуальный номер телефона'),
          fields: [
            {
              name: 'phone_number',
              label: this._('Номер телефона'),
              rules: 'required|phone',
              tag: 'phone-input',
            },
          ],
          description: this._('Обратите внимание: номер телефона должен быть правильным, поскольку на него могут приходить подтвержение по SMS и сообщения об активации билета.'),
        },
        {
          title: this._('Укажите актуальную электронную почту'),
          fields: [
            {
              name: 'email',
              label: this._('Электронная почта'),
              rules: 'required|email',
            },
          ],
          description: this._('На этот адрес могут приходить важные сообшение о верификации и участии в саммите.'),
        },
      ], [
        {
          title: this._('Выберите Ваш уровень образования и добавьте соответствующие документы(дипломы, сертификаты и т.д.)'),
          fields: [
            {
              name: 'medical_education_level',
              label: this._('Электронная почта'),
              rules: 'required',
              tag: TicketManagementEducation,
              events: {
                update: val => {
                  this.form = { ...this.form, ...val }
                },
              },
            },
          ],
        },
        {
          title: this._('Загрузите Ваше личное фото хорошего качества'),
          fields: [
            {
              name: 'photo',
              label: this._('Электронная почта'),
              rules: 'required',
              tag: TicketManagementPhoto,
              events: {
                update: val => {
                  this.form = { ...this.form, ...val }
                },
              },
            },
          ],
        },
      ], [
        {
          title: this._('Укажите город (или города), где Вы ведете профессиональную деятельность'),
          fields: [
            {
              name: 'practice_cities',
              label: this._('Выберите город'),
              rules: 'required',
              tag: 'd-control-multiselect',
              events: {
                open: () => getPaginatedPropsForArray(NOVAPOSHTA_CITIES_LINK, '', 'practice_cities', null, this.form_fields[2][0].fields),
                'search-change': $event => getPaginatedPropsForArray(NOVAPOSHTA_CITIES_LINK, $event, 'practice_cities', null, this.form_fields[2][0].fields),
              },
              afterList: $event => getPaginatedPropsForArray(NOVAPOSHTA_CITIES_LINK, '', 'practice_cities', $event, this.form_fields[2][0].fields),
              params: {
                country_available__iso_code: getCookie(COUNTRY_CODE_COOKIE_NAME) || UKRAINE_CODE,
              },
              props: {
                options: [],
                searchable: true,
                label: 'caption',
                'internal-search': false,
                search: '',
                trackBy: 'id',
                multiple: false,
                taggable: false,
                pagination: {},
                customLabel: obj => `${obj.props?.settlement_type_description} ${obj.props?.description}`,
              },
              // props: {
              //   type_name: 'cities',
              //   btnText: this._('Добавить город'),
              //   base: {
              //     settlement: '',
              //   },
              //   form_fields: [
              //     {
              //       type: 'd-control-multiselect',
              //       cols: '12 auto-xl',
              //       label: this._('Город'),
              //       name: 'settlement',
              //       tag: 'd-control-multiselect',
              //       events: {
              //         open: () => getPaginatedPropsForArray(NOVAPOSHTA_CITIES_LINK, '', 'settlement', null, this.form_fields[2][0].fields[0].props.form_fields),
              //         'search-change': $event => getPaginatedPropsForArray(NOVAPOSHTA_CITIES_LINK, $event, 'settlement', null, this.form_fields[2][0].fields[0].props.form_fields),
              //       },
              //       afterList: $event => getPaginatedPropsForArray(NOVAPOSHTA_CITIES_LINK, '', 'settlement', $event, this.form_fields[2][0].fields[0].props.form_fields),
              //       params: {
              //         country_available__iso_code: getCookie(COUNTRY_CODE_COOKIE_NAME) || UKRAINE_CODE,
              //       },
              //       props: {
              //         options: [],
              //         searchable: true,
              //         label: 'caption',
              //         'internal-search': false,
              //         search: '',
              //         multiple: false,
              //         taggable: false,
              //         pagination: {},
              //         customLabel: obj => obj.props?.description,
              //       },
              //     },
              //   ],
              // },
            },
          ],
        },
        {
          title: this._('Укажите Вашу дату рождения'),
          fields: [
            {
              name: 'birth_at',
              label: this._('Дата рождения'),
              tag: 'd-control-calendar',
              labelBy: 'key',
              rules: 'required',
              props: {
                config: {
                  disableMobile: true,
                  dateFormat: 'd.m.Y',
                },
              },
            },
          ],
        },
        {
          title: this._('Укажите год, когда Вы начали практиковать в сфере эстетической медицины'),
          fields: [
            {
              name: 'practice_start_at',
              label: this._('Год начала работы'),
              rules: 'required',
              tag: 'd-control-multiselect',
              props: {
                options: YEARS,
                searchable: false,
                label: 'key',
                'internal-search': false,
                trackBy: 'value',
                search: '',
                multiple: false,
                taggable: false,
                pagination: {},
                customLabel: obj => obj.key,
              },
            },
          ],
        },
        {
          title: this._('Укажите ссылку на Ваши профессиональные страницы'),
          fields: [
            {
              name: 'social_links',
              label: this._('Год начала работы'),
              tag: TicketManagementInliner,
              events: {
                update: val => {
                  this.form = { ...this.form, ...val }
                },
              },
              props: {
                postResource: createSocialLink,
                deleteResource: destroySocialLink,
                patchResource: updateSocialLink,
                prepare: this.prepareSocial,
                type_name: 'social_links',
                btnText: this._('Добавить другую ссылку'),
                base: {
                  is_active: true,
                  url: '',
                  social_network: '',
                },
                form_fields: [
                  {
                    name: 'social_network',
                    label: this._('Сервис соц. сети'),
                    cols: '6 4-xl',
                    type: 'd-control-multiselect',
                    props: {
                      options: [
                        { value: 'facebook', title: this._('Facebook') },
                        { value: 'viber', title: this._('Viber') },
                        { value: 'telegram', title: this._('Telegram') },
                        { value: 'instagram', title: this._('Instagram') },
                        { value: 'youtube', title: this._('Youtube') },
                        { value: 'linkedin', title: this._('Linkedin') },
                        { value: 'tiktok', title: this._('Tiktok') },
                        { value: 'other', title: this._('Інше') },
                      ],
                      label: 'title',
                      customLabel: obj => obj.title,
                    },
                  },
                  {
                    name: 'url',
                    label: this._('Ссылка'),
                    cols: '6 auto-xl',
                    inputtype: 'url',
                  },
                ],
              },
            },
          ],
        },
        {
          title: this._('Выберите Вашу специализацию(можна несколько)'),
          fields: [
            {
              label: this._('Выберите специализацию'),
              name: 'specializations',
              rules: 'required',
              tag: 'd-control-multiselect',
              events: {
                open: () => getPaginatedPropsForArray(SPECIALIZATION_URL, '', 'specializations', null, this.form_fields[2][4].fields),
                'search-change': $event => getPaginatedPropsForArray(SPECIALIZATION_URL, $event, 'specializations', null, this.form_fields[2][4].fields),
                input: this.setDefault,
              },
              afterList: $event => getPaginatedPropsForArray(SPECIALIZATION_URL, '', 'specializations', $event, this.form_fields[2][4].fields),
              props: {
                options: [],
                searchable: false,
                label: 'caption',
                'internal-search': false,
                search: '',
                multiple: true,
                taggable: false,
                pagination: {},
                customLabel: obj => obj.props?.title,
              },
            },
            {
              name: 'custom_specializations',
              label: this._('Свои специализации'),
              tag: 'd-control-textarea',
              classname: 'is-textarea',
            },
          ],
        },
        {
          title: this._('Посещали ли Вы Cadaver Course?'),
          fields: [
            {
              name: 'cadaver_course_attended',
              tag: TicketManagementRadioSelect,
            },
          ],
        },
        {
          title: this._('Вы участвовали в зарубежных медицинских поездках?'),
          fields: [
            {
              name: 'abroad_events_attended',
              tag: TicketManagementRadioSelect,
            },
          ],
        },
        {
          title: this._('Укажите основные бренды препаратов, косметики и средств, используемых в своей работе'),
          fields: [
            {
              label: this._('Выберите бренды TOTIS'),
              name: 'brands_used',
              tag: 'd-control-multiselect',
              events: {
                open: () => getPaginatedPropsForArray(BRAND_LIST_URL, '', 'brands_used', null, this.form_fields[2][7].fields),
                'search-change': $event => getPaginatedPropsForArray(BRAND_LIST_URL, $event, 'brands_used', null, this.form_fields[2][7].fields),
                // input: $event => this.setBrands($event),
              },
              afterList: $event => getPaginatedPropsForArray(BRAND_LIST_URL, '', 'brands_used', $event, this.form_fields[2][7].fields),
              default: { id: 0, props: { title: this._('Не работаю з брендами TOTIS Pharma') } },
              props: {
                options: [],
                searchable: false,
                label: 'caption',
                'internal-search': false,
                search: '',
                multiple: true,
                taggable: false,
                pagination: {},
                customLabel: obj => obj.props?.title,
                // placeholder: this._('Выберите продукт'),
              },
            },
            {
              name: 'custom_brands',
              label: this._('Свои бренды'),
              tag: 'd-control-textarea',
              classname: 'is-textarea',
            },
          ],
        },
        {
          title: this._('Перечислите все услуги, которые Вы предоставляете клиентам в косметологической практике (можно несколько)'),
          fields: [
            {
              label: this._('Выберите услуги'),
              name: 'services_provided',
              tag: 'd-control-multiselect',
              events: {
                open: () => getPaginatedPropsForArray(PARTICIPANT_SERVICES_URL, '', 'services_provided', null, this.form_fields[2][8].fields),
                'search-change': $event => getPaginatedPropsForArray(PARTICIPANT_SERVICES_URL, $event, 'services_provided', null, this.form_fields[2][8].fields),
              },
              afterList: $event => getPaginatedPropsForArray(PARTICIPANT_SERVICES_URL, '', 'services_provided', $event, this.form_fields[2][8].fields),
              props: {
                options: [],
                searchable: false,
                label: 'caption',
                'internal-search': false,
                search: '',
                multiple: true,
                taggable: false,
                pagination: {},
                customLabel: obj => obj.props?.title,
                // placeholder: this._('Выберите продукт'),
              },
            },
            {
              name: 'custom_services',
              label: this._('Другие услуги'),
              tag: 'd-control-textarea',
              classname: 'is-textarea',
            },
          ],
        },
        {
          title: this._('Проводите ли Вы обучение для других специалистов (спикерство)?'),
          fields: [
            {
              label: this._('Укажите, какие именно обучение (тема, направление и т.п.).'),
              name: 'is_lecturer',
              tag: TicketManagementCustomRadioSelect,
              has_additional: true,
              props: {
                additional_name: 'lecturer_comment',
              },
              events: {
                additional: val => {
                  this.form = { ...this.form, ...val }
                },
              },
            },
          ],
        },
        {
          title: this._('Являетесь ли Вы амбассадором бренда?'),
          fields: [
            {
              label: this._('Укажите какие именно бренды'),
              name: 'is_ambassador',
              tag: TicketManagementCustomRadioSelect,
              has_additional: true,
              props: {
                additional_name: 'ambassador_brands',
              },
              events: {
                additional: val => {
                  this.form = { ...this.form, ...val }
                },
              },
            },
          ],
        },
      ]],
      form: {
        first_name: '',
        last_name: '',
        middle_name: '',
        phone_number: '',
        email: '',
        education_documents: [],
        education_comment: '',
        practice_cities: [],
        birth_at: '',
        practice_start_at: '',
        photo: '',
        medical_education_level: '',
        specializations: [],
        custom_specializations: '',
        cadaver_course_attended: null,
        abroad_events_attended: null,
        brands_used: [],
        custom_brands: '',
        services_provided: [],
        custom_services: '',
        is_lecturer: null,
        lecturer_comment: '',
        is_ambassador: null,
        ambassador_comment: '',
        social_links: [],
        ambassador_brands: '',
      },
      non_field_errors: '',
      isLoad: false,
      currentType: null,
      brand_default: {
        id: 0,
        props: { title: this._('Не работаю з брендами TOTIS Pharma') },
      },
    }
  },
  watch: {
    'form.brands_used': {
      handler(val, oval) {
        if (!Array.isArray(val)) return;

        const hasZero = val.some(item => 0 === item.id)
        const hadZero = Array.isArray(oval) && oval.some(item => 0 === item.id)

        if (hasZero && !hadZero) {
          this.form.brands_used = [this.brand_default]
          return;
        }

        if (hadZero && 1 < val.length && hasZero) {
          this.form.brands_used = val.filter(item => 0 !== item.id)
        }
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    // setBrands(event) {
    //   console.log(event);
    //   if (event && event.length) {
    //     const noneBrand = event.filter(e => e.selected).find(item => !item.id)
    //     const hasNoneBrand = this.form.brands_used.filter(e => e.selected).find(item => !item.id)
    //     console.log(noneBrand, hasNoneBrand, event, this.form.brands_used, 'noneBrand');
    //     if (noneBrand) {
    //       if (hasNoneBrand) {
    //         this.form.brands_used = this.form.brands_used.filter(item => !!item.id)
    //         return
    //       }
    //       this.form.brands_used = [noneBrand]
    //       return
    //     }
    //   }
    //   this.form.brands_used = event
    // },
    prepareSocial(data) {
      if (data.url && data.social_network) {
        return {
          url: data.url,
          service: data.social_network.value,
          id: data.id,
        }
      }
      return false
    },
    async goNext(step) {
      const r = document.getElementById('questionary')
      if (r) r.style.display = 'none'
      if (this.$refs.validator) this.$refs.validator.reset()
      if (this.currentStep === step) return;
      if (this.currentStep > step) {
        this.currentStep = step
        return
      }
      const isValid = (await this.$refs.validator.validate())
      if (!isValid) return
      if (this.currentStep === this.steps.length) {
        this.prepareData(isValid)
        return
      }
      this.currentStep += 1
      if (this.$refs.validator) this.$refs.validator.reset()
    },
    setDefault() {
      const feedbackMethod = pathOr(null, ['props', 'input_field_type'], this.form.feedback_method)
      if (feedbackMethod) {
        if (feedbackMethod === IS_PHONE) {
          this.form.feedback_contact = window.request_phone
        } else if (feedbackMethod === IS_EMAIL) {
          this.form.feedback_contact = window.request_email
        } else if (feedbackMethod === IS_OTHER) {
          this.form.feedback_contact = ''
        }
      }
    },
    async prepareData(valid) {
      this.isLoad = true
      await this.$refs.validator.validate()
      if (!valid) return
      const data = JSON.parse(JSON.stringify(this.form))
      const res = []
      try {
        await asyncForEach(data.social_links.map(this.prepareSocial).filter(Boolean), async (el, i) => {
          const r = (await createSocialLink.execute({ label: this.ticket_hash }, el))
          res.push(r)
        })
      } catch (e) {
        console.log(e);
      }
      data.social_links = res.map(item => item.data.id)
      data.practice_cities = [pathOr(null, ['id'], this.form.practice_cities)].filter(Boolean)
      data.specializations = data.specializations.map(item => item.id)
      data.cadaver_course_attended = pathOr('', ['value'], this.form.cadaver_course_attended)
      data.abroad_events_attended = pathOr('', ['value'], this.form.abroad_events_attended)
      data.brands_used = data.brands_used.map(item => item.id).filter(Boolean)
      data.services_provided = data.services_provided.map(item => item.id)
      data.medical_education_level = pathOr('', ['value'], this.form.medical_education_level)
      data.is_lecturer = pathOr('', ['value'], this.form.is_lecturer)
      data.is_ambassador = pathOr('', ['value'], this.form.is_ambassador)
      // data.social_links = data.social_links.map(item => item.id)
      data.education_documents = data.education_documents.map(item => item.id).filter(Boolean)
      data.photo = await readFileAsync(this.form.photo)
      if (this.form.practice_start_at) {
        data.practice_start_at = `01.01.${this.form.practice_start_at.value}`
      }
      data.ticket = this.ticket
      data.filled_by = this.url ? 'buyer' : 'participant'
      if (!data.birth_at) delete data.birth_at
      if (!this.form.practice_start_at) delete data.practice_start_at
      this.submit(valid, data)
    },
    send(data) {
      this.isLoad = true
      return participantCreate.execute({ label: this.ticket_hash }, data)
        .then(() => {
          this.isLoad = false
          // window.dataLayer = window.dataLayer || []
          // window.dataLayer.push({ event: 'event_registration_topic' })
          // const message = {
          //   message: {
          //     title: this._('Participant create success header'),
          //     text: this._('Participant create success text'),
          //   },
          // }
          // AnswerMessage(message, this)
          this.success = true
          // this.$refs.validator.$el.reset()
          // this.$refs.validator.reset()
          // this.form.message = ''
          // this.$emit('close')
        }, err => {
          this.isLoad = false
          return Promise.reject(err)
        })
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      if (parsed.ticket) {
        this.non_field_errors = parsed.ticket
      }
      this.$refs.validator.setErrors(parsed)
      const top = documentOffsetTop(document.getElementById('form'))
      window.scrollTo({ top, behavior: 'smooth' })
    },
  },
}
</script>
